import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../public/assets/angle-down.svg'


const _hoisted_1 = { class: "header-dropdown" }
const _hoisted_2 = { class: "header-dropdown__button" }
const _hoisted_3 = { class: "header-dropdown__content" }
const _hoisted_4 = { class: "header-dropdown__content__element" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderDropdownAvatar = _resolveComponent("HeaderDropdownAvatar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("img", {
        src: _imports_0,
        alt: "dropdown button"
      }, null, -1 /* CACHED */)),
      _createVNode(_component_HeaderDropdownAvatar)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("a", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
        }, _toDisplayString(_ctx.t('menu.LOGOUT')), 1 /* TEXT */)
      ])
    ])
  ]))
}